import { ReactElement } from 'react';

import { BindingCreator } from '@dreryk/react-common';

import { settingsTranslationKeys } from '../../../../translations';

import { StyledAllowCustomAppointmentRequestsField } from './AllowCustomAppointmentRequestsField.styled';

type AllowCustomAppointmentRequestsFormBeanPart = {
   allowCustomAppointmentRequests: boolean;
};

type AllowCustomAppointmentRequestsFieldProps = {
   register: BindingCreator<AllowCustomAppointmentRequestsFormBeanPart>;
};

export const AllowCustomAppointmentRequestsField = (props: AllowCustomAppointmentRequestsFieldProps): ReactElement => {
   return (
      <StyledAllowCustomAppointmentRequestsField
         controller={props.register('allowCustomAppointmentRequests')}
         testId={'allowCustomAppointmentRequests'}
         label={settingsTranslationKeys.allowCustomAppointmentRequests}
      />
   );
};
